/**
 * Constantes y funciones helper para trabajar con tipos de solicitud
 * Centraliza la lógica de comparación y normalización de tipos RESPEL
 */

export const TIPOS = {
  RESIDUO_LEGACY: "Residuo",
  INGRESO_RESPEL: "Ingreso RESPEL",
  RETIRO_RESPEL: "Retiro RESPEL",
  COMPRA: "Compra",
  RETIRO_BODEGA: "Retiro Bodega",
  RENDICION: "Rendicion",
  TODOS: "Todos",
} as const;

/**
 * Verifica si el tipo es Ingreso RESPEL (incluyendo el legacy "Residuo")
 */
export function isIngresoRespel(tipoId: string | null | undefined): boolean {
  if (!tipoId) return false;
  return tipoId === TIPOS.RESIDUO_LEGACY || tipoId === TIPOS.INGRESO_RESPEL;
}

/**
 * Verifica si el tipo es Retiro RESPEL
 */
export function isRetiroRespel(tipoId: string | null | undefined): boolean {
  if (!tipoId) return false;
  return tipoId === TIPOS.RETIRO_RESPEL;
}

/**
 * Verifica si el tipo es cualquier tipo RESPEL (Ingreso o Retiro)
 */
export function isRespelTipo(tipoId: string | null | undefined): boolean {
  return isIngresoRespel(tipoId) || isRetiroRespel(tipoId);
}

/**
 * Normaliza el tipo de solicitud al valor canónico usado por la UI.
 */
export function normalizeTipoSolicitud(tipoId: string | null | undefined): string {
  if (tipoId === TIPOS.RESIDUO_LEGACY) {
    return TIPOS.INGRESO_RESPEL;
  }
  return tipoId ?? "";
}

/**
 * Verifica si el tipo es Retiro (Bodega o RESPEL)
 */
export function isRetiroTipo(tipoId: string | null | undefined): boolean {
  if (!tipoId) return false;
  return tipoId === TIPOS.RETIRO_BODEGA || tipoId === TIPOS.RETIRO_RESPEL;
}
